import axios from "../../../axios"
import { getCurrentTenant } from '@/utils'

export default {
  fetch() {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          users {
            id,
            email,
            name,
            image,
            username,
            role {
              id,
              name,
              display_name,
              has_permission_routes
            },
            isConnected,
            userDepartment {
              id,
              name,
              activated 
            }
          }
        }
      `
    })
  },
  add(user) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    user.chosenInstances = user.chosenInstances ? user.chosenInstances : []
    return axios.post('', {
      query: `
        mutation {
          newUser (
            username: "${user.username}",
            name: "${user.name}",
            email: "${user.email}",
            password: "${user.password}",
            role_id: ${user.role.id},
            user_department_id: ${user.userDepartment.id},
            chosen_instances: [${user.chosenInstances.join(',')}]
          ) {
            user {
              id,
              email,
              name,
              image,
              username,
              isConnected,
              role {
                id,
                name,
                display_name,
                has_permission_routes
              },
              userDepartment {
                id,
                name,
                activated 
              }
            }
          }
        }
      `
    })
  },
  update(user) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    user.chosenInstances = user.chosenInstances ? user.chosenInstances : []
    return axios.post('', {
      query: `
        mutation {
          updateUser (
            id: ${user.id},
            username: "${user.username}",
            name: "${user.name}",
            image: "${user.image}",
            email: "${user.email}",
            role_id: ${user.role.id},
            user_department_id: ${user.userDepartment ? user.userDepartment.id : null},
            chosen_instances: [${user.chosenInstances.join(',')}]
          ) {
            user {
              id,
              email,
              name,
              image,
              username,
              isConnected,
              role {
                id,
                name,
                display_name,
                has_permission_routes
              },
              userDepartment {
                id,
                name,
                activated 
              },
              userInstances {
                id,
                name,
                activated
              }
            }
          }
        }
      `
    })
  },
  updatePassword(user) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          updateUserPassword (
            password: "${user.password}"
          ) {
            token,
            user {
              id,
              email,
              name,
              image,
              username,
              isConnected,
              role {
                id,
                name,
                display_name,
                has_permission_routes
              },
              userDepartment {
                id,
                name,
                activated 
              }
            }
          }
        }
      `
    })
  },
  delete(userId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          deleteUser (
            id: ${userId}
          )
        }
      `
    })
  },
  infos() {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    console.log('TESTANDOOO')
    return axios.post('', {
      query: `
        query {
          userInfos {
            id,
            email,
            name,
            image,
            username,
            isConnected,
            role {
              id,
              name,
              display_name,
              has_permission_routes
            },
            isConnected,
            userDepartment {
              id,
              name,
              activated 
            },
            userInstances {
              id,
              name,
              activated
            }
          }
        }
      `
    })
  },
  fetchInstances(userId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          userInstances (
            user_id: ${userId}
          ) {
            id,
            instance {
              id,
              name,
              activated
            }
          }
        }
      `
    })
  },
  connected() {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          connected
        }
      `
    })
  },
  disconnected() {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          disconnected
        }
      `
    })
  },
  disconnectUser(userId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          disconnectUser (
            user_id: ${userId}
          )
        }
      `
    })
  },
  deleteInstance(userInstanceId) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          deleteUserInstance (
            id: ${userInstanceId}
          )
        }
      `
    })
  },
  fetchDiffInstances(removeIds = []) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          instances (
            remove_ids: [${removeIds.join(',')}]
          ) {
            id,
            name,
            activated
          }
        }
      `
    })
  },
  fetchOnlineUsers(userId = null, instanceId = null) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          onlineUsers (
            user_id: ${userId},
            instance_id: ${instanceId}
          ) {
            id,
            email,
            name,
            image,
            userDepartment {
              id,
              name
            }
          }
        }
      `
    })
  }
}
